var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_1420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99962 0C5.5855 0 1.84238 2.86112 0.516113 6.82927H19.4838C18.1578 2.86112 14.4142 0 9.99962 0Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99962 20C14.4142 20 18.1576 17.1389 19.4838 13.1703H0.516113C1.84238 17.1389 5.5855 20 9.99962 20Z",
    fill: "url(#paint0_linear_44_1420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10.0001C20 8.89134 19.8166 7.82592 19.4839 6.82922H0.516134C0.183175 7.82592 0 8.89134 0 10.0001C0 11.1088 0.183175 12.174 0.516134 13.1702H19.4839C19.8166 12.174 20 11.1088 20 10.0001Z",
    fill: "url(#paint1_linear_44_1420)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_1420",
    x1: 10,
    y1: 13.1702,
    x2: 10,
    y2: 19.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6235,
    stopColor: "#FCD447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_1420",
    x1: 0,
    y1: 9.99976,
    x2: 20,
    y2: 9.99976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED2224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E61E25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_1420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/DE.7bedd1fe1b13932ff1b777372129db4f.svg";
export { ForwardRef as ReactComponent };